import axios from "axios";

export const PressModule = {
    namespaced: true,
    state: () => ({
        news: [],
        loading: false,
        pageNumber: 1,
        filterCode: '',
        searchValue: '',
        searchActive: false,
        searchError: false,
        showMoreButton: false,
        switcher: 'news',
        calendar: ['']
    }),
    mutations: {
        SET_NEWS(state, val) {
            state.news = val;
        },
        SET_PAGE_NUMBER(state, val) {
            state.pageNumber = val;
        },
        CHANGE_SEARCH(state, val) {
            state.searchActive = val;
        },
        CHANGE_FILTER(state, val) {
            state.filterCode = val;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_SEARCH_ERROR(state, val) {
            state.searchError = val;
        },
        SET_BUTTON(state, val) {
            state.showMoreButton = val;
        },
        SET_SEARCH_VAL(state, val) {
            state.searchValue = val;
        },
        SET_SWITCHER_VAL(state, val) {
            state.switcher = val;
        },
        SET_CALENDAR_VAL(state, val) {
            state.calendar = val;
        }
    },
    actions: {
        getUrl({ state }) {
            let url = `/rest/v1/news?&page[size]=8`;
        
            if (state.calendar[0] && !state.calendar[1]) {
                state.calendar[1] = state.calendar[0];
            }
        
            // Свитчер
            url = state.switcher === 'news' ? url : `${url}&where[section]=media-about-us`;
        
            // Поиск
            url = !state.searchActive ? url : `${url}&where[search]=${state.searchValue}`;
        
            // Календарь
            url = !state.calendar[0] ? url : `${url}&where[dateFrom]=${state.calendar[0]}&where[dateTo]=${state.calendar[1]}`;
        
            // Теги
            url = !state.filterCode ? url : `${url}&where[section]=${state.filterCode}`;
        
            // Добавляем номер страницы
            url = `${url}&page[number]=${state.pageNumber}`;
        
            return url;
        },
        async getNews({ commit, dispatch }) {
            commit('SET_LOADING', true);
            let url = await dispatch('getUrl');

            const res = await axios.get(url);

            await dispatch('showMoreCheckout', res.data.meta.totalPages);
            commit('SET_NEWS', res.data.data);
            commit('SET_LOADING', false);
        },
        showMoreCheckout({ state, commit }, res) {
            if (res > state.pageNumber) {
                commit('SET_PAGE_NUMBER', state.pageNumber + 1);
                commit('SET_BUTTON', true);
                commit('SET_SEARCH_ERROR', false);
            }
            else {
                commit('SET_BUTTON', false);
            }
        },
        resetNews({ commit }) {
            commit('SET_PAGE_NUMBER', 1);
            commit('SET_NEWS', []);
        },
        async filter({ state, commit, dispatch }, val) {
            if (state.filterCode !== val) {
                await dispatch('resetNews');
            }

            if (val === '') {
                commit('CHANGE_FILTER', val);
                await dispatch('resetNews');
                await dispatch('getNews');
            }
            else {
                commit('SET_LOADING', true);
                commit('CHANGE_FILTER', val);
                let url = await dispatch('getUrl');

                const res = await axios.get(url)

                await dispatch('showMoreCheckout', res.data.meta.totalPages);
                
                const articles = !state.news.length ? res.data.data : [...state.news, ...res.data.data];
                commit('SET_NEWS', articles);
                commit('SET_LOADING', false);
            }
        },
        async search({ commit, state, dispatch }) {
            commit('SET_PAGE_NUMBER', 1);
            if (!state.searchActive) {
                await dispatch('resetNews');
            }

            if (state.filterCode) {
                commit('CHANGE_FILTER', '');
            }

            commit('SET_LOADING', true);
            const activeFlag = state.searchValue.trim() !== '' ? true : false;
            commit('CHANGE_SEARCH', activeFlag);
            let url = await dispatch('getUrl');
            const res = await axios.get(url);

            if (res.data.data.length >= 1) {
                const articles = !state.news.length ? res.data.data : [...state.news, ...res.data.data];
                commit('SET_NEWS', articles);
                commit('SET_SEARCH_ERROR', false);
            }
            else {
                commit('SET_SEARCH_ERROR', true);
            }

            commit('SET_LOADING', false);

            if (state.searchActive) {
                await dispatch('showMoreCheckout', res.data.meta.totalPages);
            }
            else {
                await dispatch('resetNews');
                await dispatch('getNews');
            }
        },
    },
};
